import { useQuery } from '@tanstack/react-query';

import type { Address } from 'viem';

import type { ParseWeiFormatOptions } from '@shared/helpers/web3/formatters';
import type { Web3Handle } from '@shared/helpers/web3/handle';

import { getTokenBalance } from './getTokenBalance';

const TOKEN_BALANCE_QUERY_ROOT_KEY = 'tokenBalance';

export const getTokenBalanceQueryKey = () => {
  return [TOKEN_BALANCE_QUERY_ROOT_KEY];
};

type UseTokenBalanceProps = Partial<Web3Handle> & {
  walletAddress?: Address;
};

type UseTokenBalanceOptions = {
  formatOptions?: ParseWeiFormatOptions;
  enabled?: boolean;
};

export const useTokenBalance = (props?: UseTokenBalanceProps, options?: UseTokenBalanceOptions) => {
  const { enabled = true } = options ?? {};

  return useQuery({
    queryKey: [TOKEN_BALANCE_QUERY_ROOT_KEY, props?.walletAddress, props?.address, props?.chainId],
    queryFn: () => getTokenBalance(props),
    enabled:
      enabled &&
      Boolean(props?.chainId) &&
      Boolean(props?.address) &&
      Boolean(props?.walletAddress),
  });
};
